import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Textra from 'react-textra';
import { testimonials } from '../models/testimonials';
function shuffleArray(items) {
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
}
function Testimonials() {
    const randomizedTestimonials = React.useMemo(() => shuffleArray(testimonials.map((testimonial) => testimonial.text)), []);
    return (_jsxs("div", { className: "testimonials-container", children: [_jsx("h2", { children: "Testimonials" }), _jsx(Textra, { effect: "rightLeft", data: randomizedTestimonials, duration: 3500 })] }));
}
export default Testimonials;
